import { type ElementMap } from '../../../stores/useEditorStore';
import { type ImageElement } from '../../image';

const BASE_PATTERN_SCALE = 0.25;
const REFERENCE_IMAGE_SIZE = 512;

const getMainImage = (elements: ElementMap): ImageElement | null => {
  for (const element of elements.values()) {
    if (element.type === 'image' && element.layer === 0) {
      return element as ImageElement;
    }
  }

  return null;
};

export const getPatternScale = (elements: ElementMap): number => {
  const mainImage = getMainImage(elements);
  if (!mainImage) return BASE_PATTERN_SCALE;

  const longerSide = Math.max(mainImage.width, mainImage.height);

  if (!Number.isFinite(longerSide) || longerSide <= 0) {
    return BASE_PATTERN_SCALE;
  }

  return BASE_PATTERN_SCALE * (longerSide / REFERENCE_IMAGE_SIZE);
};
